<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="prom-combo__value"
    id={id_Container}
    class:focused={expanded}
    class:prom-combo__value--chevron-visible={chevronVisible}
    bind:this={mainContainer}
    on:click={onClick}
    aria-controls={listboxID_forContainer}>

    <input class="prom-combo__value-input"
        id={id}
        bind:this={inputElement}
        on:keyup={keyUp}
        on:keydown={keyDown}
        required="{required}"
        role="combobox"
        aria-controls={listboxID_forInput}
        aria-expanded={expanded}
        aria-haspopup={inputAriaHasPopup}
        aria-autocomplete={ariaAutocomplete}
        aria-activedescendant={listboxFocusedID}/>

    <div class="prom-combo__focus-wrapper"></div>
</div>

<script>
    import { Keys } from '@itslearning/atlas/keyboard/keys';
    import { normalizeKey } from '@itslearning/atlas/keyboard/normalize';
    import { isPrintableCharacter } from './helpers';

    import { createEventDispatcher } from 'svelte';

    export let id;
    export let enableAutoComplete;
    export let enableInlineAutoComplete;
    export let listboxFocusedID = undefined;
    export let expanded;
    export let dataProvider;
    export let chevronVisible;
    export let required;

    let value;
    let filter = '';

    $: id_Container = `container_${id}`;

    /** @type {'listbox'} */
    $: inputAriaHasPopup = expanded ? 'listbox' : undefined;

    /** @type {'both' | 'list' | 'none'} */
    $: ariaAutocomplete = enableAutoComplete
        ? (enableInlineAutoComplete ? 'both' : 'list')
        : 'none';

    $: listboxID_forContainer = `listbox_${id}`;
    $: listboxID_forInput = expanded ? 'listbox_' + id : undefined;

    let mainContainer, inputElement;
    let displayValue;

    const dispatch = createEventDispatcher();

    export function checkIfFocused() {
        return document.activeElement === mainContainer || document.activeElement === inputElement;
    }

    export function containsTarget(target) {
        return mainContainer === target || mainContainer.contains(target);
    }

    export function focus() {
        inputElement.focus();
    }

    export function reset() {
        value = undefined;
        setDisplayValue(null);
    }

    export function getStrValue() {
        return inputElement.value;
    }

    export function setDisplayValue(value) {
        displayValue = value;
        if (inputElement) {
            inputElement.value = value ? value : null;
        }
    }

    export function setValue(newValue) {
        value = newValue;
    }

    export function checkIfEmpty() {
        return !inputElement.value;
    }

    function keyDown(event) {
        if (normalizeKey(event.key) === Keys.TAB) {
            value = inputElement.value;
        }
    }

    async function keyUp(event) {
        let preventDispatchFilter = false;
        let preventInlineGuess = false;
        const char = event.key;

        if (isPrintableCharacter(char)) {
            filter += char;
        } else {
            preventInlineGuess = true;
        }

        if (inputElement.value.length < filter.length) {
            filter = inputElement.value;
        }

        switch (normalizeKey(event.key)) {
            case Keys.ENTER: {
                value = inputElement.value;
                createSelection(0, value.length);
                dispatch('commit', value);
                dispatch('closePopup', value);
                preventInlineGuess = true;
                preventDispatchFilter = true;
                break;
            }
            case Keys.TAB:
            case Keys.UP:
            case Keys.DOWN:
            case Keys.ESCAPE:
            case 'Control':
            case 'Alt':
            case 'Shift': {
                preventDispatchFilter = true;
                break;
            }
        }

        if (!preventDispatchFilter) {
            dispatch('filter', filter);
        }

        if (!preventInlineGuess && enableInlineAutoComplete) {
            await displayInlineGuess();
        }
    }

    function createSelection(start, end) {
        inputElement.focus();
        inputElement.setSelectionRange(start, end);
    }

    async function displayInlineGuess() {
        const inlineGuess = await getInlineGues(filter);
        if (inlineGuess) {
            inputElement.value = inlineGuess.guess;
            createSelection(inlineGuess.index, inlineGuess.guess.length);
        }
    }

    async function getInlineGues(filter) {
        const filtered = await Promise.resolve(dataProvider.getOptions(filter));
        if (filtered.length === 0) {
            return null;
        }

        const first = filtered[0];

        return {
            guess: first.label,
            index: filter.length
        };
    }

    function onClick(event) {
        if (event.target !== inputElement) {
            inputElement.focus();
        }
    }
</script>
